import { createContext, useContext, useReducer } from "react";

export const OutStockStore = createContext<IContextProps>(null);

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

class Search {
    keywords: string;
    shopId: string;
    shopName: string;
    goodsId: string;
    goodsName: string;
    shop:any;
    goods:any;
};

interface IState {
    searchList: any[];
    search: Search;
}

const initialArgs: IState = {
    searchList: [],
    search: new Search()
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case "SetSearch":
            return {
                ...state,
                search: {
                    ...state.search,
                    ...payload
                }
            }
        case "SetSearchList":
            return {
                ...state,
                searchList: payload
            }
        default:
            return state;
    }
}

export function OutStockStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <OutStockStore.Provider value={v}>{props.children}</OutStockStore.Provider>
}